export const JASPER52_ID = 5584;
export const ACME_ID = 869;
